import type { TenantExistsResponse } from "@bezoned/shared/types/api/tenant/tenant-exists.types.js";
import { createContext, useContext } from "react";

type ExistingTenant = Extract<TenantExistsResponse, { exists: true }>;

export interface TenantContextType {
  tenant: ExistingTenant;
}

export const TenantContext = createContext<TenantContextType | null>(null);

export const useTenant = (): ExistingTenant => {
  const context = useContext(TenantContext);

  if (!context) {
    throw new Error(
      "useTenant must be used within a TenantExistsGuard context"
    );
  }

  return context.tenant;
};
